<template>
  <a-layout class='s_bf'>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-button type="primary" @click='choose(record)' :ghost="!record.select" v-if='!checkout'>选择</a-button>
          <a-button type="primary" @click='choose(record)' :ghost="!record.select" v-else>选择</a-button>
        </template>
      </a-table>
      <div class="s_flex_center m-t-25" v-if='checkout'>
        <a-button type="primary" @click='confirm'>确定</a-button>
      </div>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import {
    getMemberVip,
  } from "@/api/member";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
  };
  export default {
    name: "selectCard",
    props: {
      checkout: Boolean,
      selectList: {
        type: Array
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref();
      search.value = { ...defSearch }
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        checkbox: [],
        listLoading: false,
        time: [],
        total: 1,
        loadData: [],
        status: 1,
        selectList: [],//被选中的列表
      });
      let columns = [
        {
          title: "ID编号",
          dataIndex: "vip_id",
          key: "info"
        },
        {
          title: "等级名称",
          dataIndex: "vip_name",
          key: "vip_name"
        },
        {
          title: "所需成长值",
          dataIndex: "vip_exp",
          key: "vip_exp"
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const form = ref();
      const reset = () => {
        search.value = defSearch
        form.value.resetFields()
        state.checkbox = []
        search.value.ex_gift_cate_id = ""
      };
      const initData = async (values) => {
        var json = JSON.parse(JSON.stringify(search.value))
        for (var i = 0; i < state.checkbox.length; i++) {
          json[state.checkbox[i]] = 1
        }
        state.listLoading = true;
        let res = await getMemberVip(search.value).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          if (state.selectList.length > 0) {
            data.value.forEach(i => {
              if (state.selectList.find(v => i.vip_id == v.vip_id)) {
                i.select = true
              }
            })
          }
        } else {
          message.error(res.msg);
        }
      };

      //单选
      const select = (e) => {
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.vip_id == e.vip_id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      }
      const choose = (e) => {
        if (props.checkout) {
          checkBnt(e)
        } else {
          select(e)
        }
      }
      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        confirm,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        reset,
        form,
        choose
      };
    },
  };
</script>